import { AdditionalField, WidgetBody } from 'features/settings/mobile-editor/interfaces';
/**
 * Ищет в списке доп полей объект соответствующий объекту виджет
 * */
export const findMatchingField = (widget: WidgetBody, additionsList: AdditionalField[]): AdditionalField | void => additionsList.find((field: AdditionalField) => Object.keys(widget).some((key) => {
  if (widget[key] && typeof widget[key] === 'string') {
    return widget[key] === field.formCode;
  }
}));
